import axios from "axios";

export const applyService = async (data) => {
  try {
    await axios.post('https://api.fintrekmarketing.com/apply-home', data)
    return {
      status: "success",
      message: "Operation Success!"
    }
  } catch (error) {
    return {
      status: "failed",
      error: "Failed due to error: " + error.message
    }
  }
}

export const applyContact = async (data) => {
  try {
    await axios.post('https://api.fintrekmarketing.com/apply-contact', data);
    return {
      status: "success",
      message: "Operation Success!"
    }
  } catch (error) {
    return {
      status: "failed",
      error: "Failed due to error: " + error.message
    }
  }
}

export const getVacancyList = async () => {
  try {
    let respData = await axios.get('https://admin.fintrekmarketing.com/api/careers?populate=*', {
      headers: {
        'Authorization': 'Bearer 13a6b1e44fa18cc3aab3e50aad1135dd0aafa99af53d9ea3b127d502090b0d334fac00b1971e07267387ac33d3f3d48085b4524bca10549e7867cf9ed7a8493b69f0d8bc988fa6b7a2c672eeb99842ddbbf5ea5454e5d55538727a972110533806f69b3076c3362d93bd6a315227d75c9800f8e4762b0713e8804206051b2de9'
      }
    })
    return {
      status: "success",
      message: "Vacancies fetched successfully",
      result: respData.data.data
    }
  } catch (error) {
    return {
      status: "failed",
      error: "Failed due to error: " + error.message
    }
  }
}

export const applyOffer = async (formData) => {
  try {
    console.log(formData)
    const data = new FormData()
    data.append('data', JSON.stringify({
      firstName: formData.fname,
      lastName: formData.lname,
      email: formData.email,
      phone: formData.contact,
      gender: formData.gender,
      nationality: formData.nationality,
      experience: formData.experience,
      currentPosition: formData.position,
      salaryExpectation: formData.salary,
      address: formData.address,
      coverLetter: formData.cover || '',
      careerId: formData.careerId
    }))
    
    if (formData.resume) {
      data.append('files.resume', formData.resume)
    }
    
    await axios.post('https://admin.fintrekmarketing.com/api/applications', data, {
      headers: {
        'Authorization': 'Bearer 13a6b1e44fa18cc3aab3e50aad1135dd0aafa99af53d9ea3b127d502090b0d334fac00b1971e07267387ac33d3f3d48085b4524bca10549e7867cf9ed7a8493b69f0d8bc988fa6b7a2c672eeb99842ddbbf5ea5454e5d55538727a972110533806f69b3076c3362d93bd6a315227d75c9800f8e4762b0713e8804206051b2de9',
        'Content-Type': 'multipart/form-data',
      },
    })
    return {
      status: "success",
      message: "Application submitted successfully!",
    }
  } catch (error) {
    return {
      status: "failed",
      error: "Failed due to error: " + error.message,
    }
  }
}

export const getCreditCards = async () => {
  try {
    let respData = await axios.get('https://admin.fintrekmarketing.com/api/credit-cards?populate=*', {
      headers: {
        'Authorization': 'Bearer 13a6b1e44fa18cc3aab3e50aad1135dd0aafa99af53d9ea3b127d502090b0d334fac00b1971e07267387ac33d3f3d48085b4524bca10549e7867cf9ed7a8493b69f0d8bc988fa6b7a2c672eeb99842ddbbf5ea5454e5d55538727a972110533806f69b3076c3362d93bd6a315227d75c9800f8e4762b0713e8804206051b2de9'
      }
    })
    return {
      status: "success",
      message: "Credit cards fetched successfully",
      result: respData.data.data
    }
  } catch (error) {
    return {
      status: "failed",
      error: "Failed due to error: " + error.message
    }
  }
}